import { SelectOptionType } from '@octano/global-ui';
import dayjs from 'dayjs';
import {
  ModalFormData,
  defaultValues,
} from './parts/Modals/CreateOrUpdateModalForm';
import { EducationalBackgroundType, EducationRecord } from './type';

const optionFormat = (option: { id: number; name: string }) => ({
  label: option.name,
  value: option.id,
});

const optionFormatInstitution = (e: {
  id: number;
  name: string;
  code?: string | null;
  countryId?: string | null;
}) => {
  return {
    value: e.id,
    label: e.code ? `(${e.code}) - ${e.name}` : e.name,
    code: e.code,
    countryId: e.countryId,
  };
};

export const educationRecordToForm = ({
  type,
  row,
  institutionsOther,
  recognizedOptions = [],
}: {
  type: EducationalBackgroundType;
  row?: EducationRecord;
  institutionsOther: SelectOptionType;
  recognizedOptions: SelectOptionType[];
}): Partial<ModalFormData> =>
  row
    ? {
        type,
        id: row?.id ?? null,
        name: row?.name?.trim() ?? '',
        studyCarriedOut: row?.studyCarriedOut?.trim() ?? '',
        isRecognized:
          recognizedOptions.find(
            (e) => row?.isRecognized === (e.value as any),
          ) ?? null,
        originInstituteCustom: row?.originInstituteCustom?.trim() ?? '',
        description: row?.description?.trim() ?? '',
        dateOfIssue: dayjs(row.dateOfIssue).toDate(),
        country: row.country ? optionFormat(row.country as any) : null,
        specialtyType: row.specialtyType
          ? optionFormat(row.specialtyType as any)
          : null,
        degreeLevel: row.degreeLevel
          ? optionFormat(row.degreeLevel as any)
          : null,
        institution: row.institution
          ? optionFormatInstitution(row.institution as any)
          : institutionsOther,
        files:
          row.files?.map((e) => ({
            code: e.code,
            fileUrl: e.fileUrl,
            linkedFile: new File(
              [] as any,
              `${e?.linkedFile?.name}.${e?.linkedFile?.extension}`,
              { lastModified: -1 },
            ),
          })) ?? [],
      }
    : { ...defaultValues, type };
